
<template>
  <div class="yuanyin">
    <popup ref="defeatPopup" type="center" @close="close">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么Ai视频创作会比较慢？</div>
            <div class="item_answer">
              答：视频生成对算力的消耗极大，尤其是高分辨率和高帧率的视频生成。生成视频时需要处理大量的数据和复杂的计算任务，这使得生成速度相对较慢！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么Ai视频创作会提示失败？</div>
            <div class="item_answer">
              答：因为Ai视频创作全部为Ai原创，可能会出现违规低俗内容，这些视频会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn" @click="close">好的，我知道了</button>
      </div>
    </popup>
  </div>

</template>

<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"

export default {
  components: {popup},
  data() {
    return {

    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    show() {
      this.$refs.defeatPopup.show();
    },
    close() {
      this.$refs.defeatPopup.close();
    },
  },
};
</script>
<style scoped lang="scss">
.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
    color: #000;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;
      .item_question{
        color: #000;
      }
      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}
</style>